export const dateToString = (dateUnformatted: string, lang: string) => {
  const unformattedDate = new Date(dateUnformatted);

  const day = unformattedDate.getUTCDate().toString().padStart(2, '0');
  const month = (unformattedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = unformattedDate.getFullYear();

  if (lang === 'br'){
    const formattedBrDate = `${day}/${month}/${year}`;
    return formattedBrDate;
  }
  else {
    const formattedEnDate = `${month}/${day}/${year}`;
    return formattedEnDate;
  }
};

export const dateTimeToString = (dateUnformatted: string, lang: string) => {
  const unformattedDate = new Date(dateUnformatted);

  const day = unformattedDate.getUTCDate().toString().padStart(2, '0');
  const month = (unformattedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = unformattedDate.getFullYear();

  const hours = unformattedDate.getUTCHours().toString().padStart(2, '0');
  const minutes = unformattedDate.getUTCMinutes().toString().padStart(2, '0');
  const seconds = unformattedDate.getUTCSeconds().toString().padStart(2, '0');

  const time = `${hours}:${minutes}:${seconds}`;

  if (lang === 'br') {
    const formattedBrDate = `${day}/${month}/${year} ${time}`;
    return formattedBrDate;
  } else {
    const formattedEnDate = `${month}/${day}/${year} ${time}`;
    return formattedEnDate;
  }
};

export const br = {
  firstDayOfWeek: 1,
  dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
  dayNamesShort: ["Dom", "Seg", "Ter", "Quar", "Qui", "Sex", "Sáb"],
  dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
  monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  today: 'Hoje',
  clear: 'Limpar',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sm'
};